import { render, staticRenderFns } from "./APPHomeListSort.vue?vue&type=template&id=83d2c9c8&scoped=true&"
import script from "./APPHomeListSort.vue?vue&type=script&lang=js&"
export * from "./APPHomeListSort.vue?vue&type=script&lang=js&"
import style0 from "./APPHomeListSort.vue?vue&type=style&index=0&id=83d2c9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d2c9c8",
  null
  
)

export default component.exports